<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container" v-if="modulo!=0">
            <router-link v-if="p_pagina=='P'" to="/persona">Personas</router-link>
            <router-link v-if="p_pagina=='M'" to="/medico">Médicos</router-link>
            > {{ datoPersona.nombreCompleto }}
          </div>
          <div class="breadcrumb-container" v-else>
            <router-link to="/MenuPrincipal">Inicio</router-link>
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
<!-- Area de notificación -->
<!--     <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
      <div class="notification-message"
        :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
        {{ notificacion.message }}
      </div>
    </div> -->
    <Modal v-model:modelValue="showModalHelp">
      <AyudaPersonaForm />
    </Modal>
    <hr>
    <!-- Modal -->
    <div class="modal-dialog modal-xl" style="z-index: 1;">
      <div class="modal-content">
        <div class="d-flex justify-content-between align-items-center">
          <b>Datos Persona</b>
          <button
            class="btn btn-link p-0 text-decoration-none"
            @click.prevent="mostrarBloque = !mostrarBloque"
          >
            <span class="material-symbols-outlined align-middle">
              {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
            </span>
            {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más' }}
          </button>
        </div>
        <div v-if="mostrarBloque">
		<form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoIden" class="form-label"> Tipo Id.</label>
                </div>
                <div class="col-2">
                  <select class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoPersona.idTipoIden">
                    <option v-for="tipoIden in tipoIdens" :value="tipoIden.idTipoIden" :key="tipoIden.idTipoIden">
                      {{ tipoIden.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-2">
                  <input type="text" class="form-control" id="documento" name="documento" v-model="datoPersona.documento"
                    style='text-transform:uppercase' required>
                </div>
                <div class="col-2">
                  <label for="idEstadoCivil" class="form-label"> Estado Civil</label>
                </div>
                <div class="col-2">
                  <select class="form-control" id="idEstadoCivil" name="idEstadoCivil"
                    v-model="datoPersona.idEstadoCivil">
                    <option v-for="estadoCivil in estadoCivils" :value="estadoCivil.idEstadoCivil"
                      :key="estadoCivil.idEstadoCivil">
                      {{ estadoCivil.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaNac" class="form-label">Fecha Nac.</label>
                </div>
                <div class="col-2">
                  <input type="date" class="form-control" id="fechaNac" name="fechaNac" v-model="formattedFechaNac"
                    required>
                </div>
                <div class="col-2">
                  <label for="sexo" class="form-label">Sexo</label>
                </div>
                <div class="col-2">
                  <select class="form-control" id="sexo" name="sexo" v-model="datoPersona.sexo" required>
                    <option value="">Seleccione el género</option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                </div>
                <div class="col-2">
                  <label for="telefono" class="form-label">Teléfono</label>
                </div>
                <div class="col-2">
                  <input type="text" class="form-control" id="telefono" name="telefono" v-model="datoPersona.telefono"
                    style='text-transform:uppercase' required>
                </div>                
              </div>
            </div>            
            <!-- Botón Lista de Valores  Tipo Iden -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerNombre" class="form-label">Primer Nombre</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="primerNombre" name="primerNombre"
                    v-model="datoPersona.primerNombre" style='text-transform:uppercase' required>
                </div>
                <div class="col-2">
                  <label for="segundoNombre" class="form-label">Segundo Nombre</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="segundoNombre" name="segundoNombre"
                    v-model="datoPersona.segundoNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerApellido" class="form-label">Primer Apellido</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="primerApellido" name="primerApellido"
                    v-model="datoPersona.primerApellido" style='text-transform:uppercase' required>
                </div>
                <div class="col-2">
                  <label for="segundoApellido" class="form-label">Segundo Apellido</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="segundoApellido" name="segundoApellido"
                    v-model="datoPersona.segundoApellido" style='text-transform:uppercase' required>
                </div>                
              </div>
            </div>
            <!-- Botón Lista de Valores  Localidad -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idLocalidad" class="form-label">Localidad</label>
                </div>
                <div class="col-4">
                  <select class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoPersona.idLocalidad">
                    <option v-for="localidad in localidads" :value="localidad.idLocalidad" :key="localidad.idLocalidad">
                      {{ localidad.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <label for="email" class="form-label">Email</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="email" name="email" v-model="datoPersona.email" required>
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Localidad -->            
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="direccion" name="direccion" v-model="datoPersona.direccion"
                    style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
<!--
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoPersona" class="form-label">TipoPersona</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="tipoPersona" name="tipoPersona"
                    v-model="datoPersona.tipoPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
-->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label">IdPersona</label>
                  </div>
                  <div class="col-4">
                    <span id="idPersona" class="form-control-plaintext">{{ datoPersona.idPersona }}</span>
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-4">
                    <span id="fechaReg" class="form-control-plaintext">{{ getFormattedDateTime(datoPersona.fechaReg) }}</span>
                  </div>
                </div>
              </div>
          </div>
        </form>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <div>
            <button type="submit" class="btn btn-light" @click.prevent="agendarCita" title="Agendar Cita">
              <i class="material-icons" style="font-size:32px;color:green; cursor: pointer;">calendar_month</i> Agendar Cita
            </button>
            <button type="button" class="btn btn-light" @click="verVacunas()">
              <span class="material-symbols-outlined" style="font-size: 32px; color: blue;">vaccines</span>
              Vacunas
            </button>
          </div>
          <div>
            <button type="submit" class="btn btn-light" @click.prevent="guardarEditPersona" v-if="btnEditar"
              title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>

<!-- Estructura de Tabs -->
<div class="tab-bar mt-3">
  <button class="tablink" @click="showTable = 'medico'"
    :class="{ 'active-tab': showTable === 'medico' }">
    <span class="material-symbols-outlined">medical_information</span>
    Registro como Médico
  </button>
  <button class="tablink" @click="showTable = 'citas'"
    :class="{ 'active-tab': showTable === 'citas' }">
    <span class="material-symbols-outlined">calendar_month</span>
    Citas
  </button>
  <button class="tablink" @click="showTable = 'atenciones'"
    :class="{ 'active-tab': showTable === 'atenciones' }">
    <span class="material-symbols-outlined">list_alt</span>
    Atenciones
  </button>
<!--  
  <button class="tablink" @click="showTable = 'bitacora'"
    :class="{ 'active-tab': showTable === 'bitacora' }">
    <span class="material-symbols-outlined">overview</span>
    Bitácora
  </button>
-->
<!--
  <button class="tablink" @click="showTable = 'seguros'"
    :class="{ 'active-tab': showTable === 'seguros' }">
    <span class="material-symbols-outlined">health_and_safety</span>
    Seguros
  </button>
-->
<!--
  <button class="tablink" @click="showTable = 'usuarios'"
    :class="{ 'active-tab': showTable === 'usuarios' }">
    <span class="material-symbols-outlined">person_add</span>
    Usuario
  </button>
-->
  <button class="tablink" @click="showTable = 'medios'"
    :class="{ 'active-tab': showTable === 'medios' }">
    <span class="material-symbols-outlined">phone_in_talk</span>
    Medios de Comunicación
  </button>
</div>

<div v-if="showTable === 'medico' && dataLoaded">
  <PersonaMedico :p_idPersona="p_idPersona" />
</div>
<div v-if="showTable === 'citas'">
  <PersonaCita :p_idPersona="p_idPersona" />
</div>
<div v-if="showTable === 'atenciones'">
  <PersonaAtencion :p_idPersona="p_idPersona" />
</div>
<div v-if="showTable === 'bitacora'">
  <Bitacora :p_idPersona="p_idPersona" />
</div>
<div v-if="showTable === 'seguros'">
  <Seguro :p_idPersona="p_idPersona" />
</div>
<div v-if="showTable === 'usuarios'">
  <PersonaUsuario :p_idPersona="p_idPersona" :p_email="datoPersona.email" />
</div>
<div v-if="showTable === 'medios'">
  <MedioPers :p_idPersona="p_idPersona" />
</div>

    <Footer />
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaPersonaForm from '@/views/ayuda/AyudaPersonaForm.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
import MedioPers from '../forms/MedioPers.vue';
import PersonaMedico from '../forms/PersonaMedico.vue';
import PersonaCita from '../forms/PersonaCita.vue';
import PersonaAtencion from '../forms/PersonaAtencion.vue';
import PersonaUsuario from '../forms/PersonaUsuario.vue';
import Bitacora from '../forms/Bitacora.vue';
import Seguro from '../forms/Seguro.vue';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {

  props: {
    p_pagina:    { type: String, required: true },
    p_idpersona: { type: String, required: true },
  },

  components: {
    Layout, Footer, AyudaPersonaForm
    , MedioPers
    , PersonaMedico
    , PersonaCita
    , PersonaAtencion
    , PersonaUsuario
    , Bitacora
    , Seguro
  },
  data() {
    return {
      personas: [],
      datoPersona: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: true,
      modalWindow: true,
      p_idPersona: 0,
      tipoIdens: [],
      localidads: [],
      estadoCivils: [],
      showTable: 'medico',
      mostrarBloque: true,
      showNotifications: false,
      notificaciones: [],
      popupAyuda: false,
      modulo: 0,
      dataLoaded: false,
      showModalHelp: false,
    }
  },
  computed: {
    formattedFechaNac: {
      get() {
        if (!this.datoPersona.fechaNac) return '';
        const date = new Date(this.datoPersona.fechaNac);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoPersona.fechaNac = date.toISOString();
      }
    }
  },
  mounted() {
    this.modulo = window.sessionStorage.getItem("modulo")
    this.p_idPersona = this.p_idpersona
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchTipoIdens()
    this.fetchLocalidads()
    this.fetchEstadoCivils()
  },
  methods: {
    getFormattedDateTime(date) {
      return dateFormat.getFormattedDateTime(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    
    getData() {
      api.get('/vwpersonas/' + this.p_idPersona)
        .then(response => {
          this.datoPersona = response.data;
          this.dataLoaded = true;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
        });
    },
    validarPersona(){
      const requiredFields = [
        'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
        ,'sexo'
        ,'email'
      ];
      const requiredFieldsText = [
        'idTipoIden'
        ,'idLocalidad'
        ,'idEstadoCivil'
        ,'documento'
        ,'primerNombre'
        ,'segundoNombre'
        ,'primerApellido'
        ,'segundoApellido'
        ,'fechaNac'
        ,'direccion'
        ,'telefono'
          ,'sexo'
        ,'email'
      ];
      return validarForm(this.datoPersona, requiredFields, requiredFieldsText);
    },
/*     async guardarPersona() {
      if (this.validarPersona() === 1) {
        try {
          this.datoPersona.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/personas', this.datoPersona)
//          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Persona creada exitosamente!", "success");
//          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    }, */
    async guardarEditPersona() {
      if (this.validarPersona() === 1) {
        try {
          await api.post('/personas', this.datoPersona)
//          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Persona actualizada exitosamente!", "success");
//            this.notificaciones.push({ message: "Persona creada exitosamente!", type: "success" });
//          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!"+error.response.data.message, "error");
//          this.notificaciones.push({ message: "Intentelo de nuevo!"+error.response.data.message, type: "error" });
        }
      }
    },
    agendarCita() {
      this.$router.push('/pacientecita02/'+this.datoPersona.idPersona+'/0/0');
    },
fetchTipoIdens() {
  api.get('/vwtipoidens')
    .then(response => { this.tipoIdens = response.data; })
    .catch(error => console.error('Error fetching tipoIdens:', error));
},
fetchLocalidads() {
  api.get('/vwlocalidads')
    .then(response => { this.localidads = response.data; })
    .catch(error => console.error('Error fetching localidads:', error));
},
fetchEstadoCivils() {
  api.get('/vwestadocivils')
    .then(response => { this.estadoCivils = response.data; })
    .catch(error => console.error('Error fetching estadoCivils:', error));
},
    verVacunas() {
      // Calcular la edad con mayor precisión (años, meses, días)
      const daysInYear = 365.25; // Considera los años bisiestos

      const years = parseInt(this.datoPersona.edadNacYears, 10) || 0;
      const months = parseInt(this.datoPersona.edadNacMonths, 10) || 0;
      const days = parseInt(this.datoPersona.edadNacDays, 10) || 0;

      const totalDays = (years * daysInYear) + (months * 30) + days;

      // Calcular la edad en años, redondeada
      const edad = Math.round(totalDays / daysInYear);
      this.$router.push('/persona_vacunapers/' + this.p_pagina + '/0/0/' + this.datoPersona.idPersona + '/' + edad);
    },
    verAlergias() {
      // Calcular la edad con mayor precisión (años, meses, días)
      const daysInYear = 365.25; // Considera los años bisiestos

      const years = parseInt(this.datoPersona.edadNacYears, 10) || 0;
      const months = parseInt(this.datoPersona.edadNacMonths, 10) || 0;
      const days = parseInt(this.datoPersona.edadNacDays, 10) || 0;

      const totalDays = (years * daysInYear) + (months * 30) + days;

      // Calcular la edad en años, redondeada
      const edad = Math.round(totalDays / daysInYear);
      this.$router.push('/persona_vacunapers/0/0/' + this.datoPersona.idPersona + '/' + edad);
    },
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    }
  },
}
</script>
<style scoped>
.tab-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 6px 8px 0;
  flex-wrap: wrap;
}
.tablink {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 12px 8px;
  border: 1px solid transparent;
  border-bottom: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  transition: background .15s, color .15s;
}
.tablink:hover { background: #e9ecef; color: #343a40; }
.active-tab {
  background: #fff;
  color: #0d6efd;
  border-color: #dee2e6;
  font-weight: 500;
  margin-bottom: -2px;
  border-bottom: 2px solid #fff;
}
</style>
<style src="@/assets/css/alertas.css" scoped></style>